import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { stylingHelpers } from '../../designTokens';
import ShadowBox from '../chrome/ShadowBox';
import Image from '../chrome/Image';
import ColorProvider from '../chrome/ColorProvider';
import Text from '../chrome/Text';
import List from '../chrome/List';

const { flexCenter } = stylingHelpers;

const containerBaseStyles = () => css`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

const Container = styled('div')(containerBaseStyles);

const imageWrapperBaseStyles = () => css`
  display: flex;
  align-items: center;
  max-width: 20px;
  height: 20px;
  overflow: hidden;
`;

const ImageWrapper = styled('div')(imageWrapperBaseStyles);

const tierHeaderBaseStyles = ({ theme }) => css`
  padding: ${theme.spacings.mega} ${theme.spacings.giga};
  width: 100%;
`;

const TierHeader = styled('div')(tierHeaderBaseStyles);

const tierBodyBaseStyles = ({ theme }) => css`
  padding: 0 ${theme.spacings.bit} ${theme.spacings.byte} ${theme.spacings.giga};
  width: 100%;
`;

const TierBody = styled('div')(tierBodyBaseStyles);

const entryItemBaseStyles = ({ theme }) => css`
  margin-bottom: ${theme.spacings.kilo};
  margin-right: ${theme.spacings.kilo};
  width: calc(100% / 10 - ${theme.spacings.kilo});
`;

const EntryItem = styled('li')(entryItemBaseStyles);

const tierFooterBaseStyles = ({ theme }) => css`
  border-top: ${theme.borderWidth.kilo} solid ${theme.colors.n500};
  padding: ${theme.spacings.byte} ${theme.spacings.giga};
  width: 100%;

  span {
    color: ${theme.colors.r500};
    font-weight: ${theme.fontWeight.bold};
  }
`;

const TierFooter = styled('div')(tierFooterBaseStyles);

const tierFooterWrapperBaseStyles = () => css`
  ${flexCenter()}
`;

const TierFooterWrappr = styled('div')(tierFooterWrapperBaseStyles);

const Tier = ({ title, tickets, tierLocked, footerContent: FooterContent }) => (
  <ShadowBox>
    <Container>
      <TierHeader>
        <ColorProvider variant={tierLocked ? 'grey' : 'black'}>
          <Text size='giga' bold noMargin>
            {title}
          </Text>
        </ColorProvider>
      </TierHeader>
      {!tierLocked && (
        <TierBody>
          <List noBullets inline>
            {tickets.map(({ src }, index) => (
              <EntryItem key={index}>
                <ImageWrapper>
                  <Image src={src} />
                </ImageWrapper>
              </EntryItem>
            ))}
          </List>
        </TierBody>
      )}
      {FooterContent && (
        <TierFooter>
          <TierFooterWrappr>
            <FooterContent />
          </TierFooterWrappr>
        </TierFooter>
      )}
    </Container>
  </ShadowBox>
);

Tier.propTypes = {
  title: PropTypes.string,
  tickets: PropTypes.array,
  tierLocked: PropTypes.bool,
  footerContent: PropTypes.func,
};

export default Tier;
